// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3LIDX","dragIcon":"SortableItem_dragIcon__V9T0-","disabled":"SortableItem_disabled__11b3V"};